import { ConvexReactClient, ConvexProvider } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ReactNode } from "react";
import { useAuth } from "@clerk/clerk-react";
import { isAuthBypassEnabled } from "./AuthBypass";

// Only initialize Convex if we have a URL configured
const convexUrl = import.meta.env.VITE_CONVEX_URL;

let convex: ConvexReactClient | null = null;

try {
  if (convexUrl) {
    convex = new ConvexReactClient(convexUrl);
    console.log("✓ Convex initialized:", convexUrl);
  } else {
    console.warn("⚠ Convex not configured - using local storage fallback");
  }
} catch (error) {
  console.error("✗ Convex initialization failed:", error);
  convex = null;
}

interface ConvexProviderWrapperProps {
  children: ReactNode;
}

export function ConvexProviderWrapper({ children }: ConvexProviderWrapperProps) {
  if (!convex) {
    // If Convex is not configured, just render children without the provider
    return <>{children}</>;
  }

  // In bypass mode, use plain ConvexProvider (no Clerk auth)
  if (isAuthBypassEnabled()) {
    return (
      <ConvexProvider client={convex}>
        {children}
      </ConvexProvider>
    );
  }

  // Normal mode: use ConvexProviderWithClerk for authenticated access
  return (
    <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
      {children}
    </ConvexProviderWithClerk>
  );
}

export const useConvexClient = () => convex;